import locale from "./de.json";

export default locale;
